import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home.js';
import KredytyFirmowe from './pages/KredytyFirmowe.js';
import KredytyHipoteczne from './pages/KredytyHipoteczne.js';
import Leasingi from './pages/Leasingi.js';
import Onas from './pages/Onas.js';
import Personalmedia from './pages/Personalmedia.js';
import Prawo from './pages/Prawo.js';
import NotFound from "./pages/NotFound.js";
import PozyczkiUnijne from "./pages/PozyczkiUnijne.js";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="/onas" element={< Onas/>} />
          <Route path="/personalmedia" element={< Personalmedia/>} />
          <Route path="/prawo" element={< Prawo/>} />
          <Route path="/kredytyfirmowe" element={< KredytyFirmowe/>} />
          <Route path="/pozyczkiunijne" element={< PozyczkiUnijne/>}/>
          <Route path="/kredytyhipoteczne" element={< KredytyHipoteczne/>} />
          <Route path="/leasingi" element={< Leasingi/>} />
          <Route path="*" element={<NotFound />} /> 
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
